export const posthogApiKey = import.meta.env.VITE_POSTHOG_API_KEY || "";
export const posthogHost = import.meta.env.VITE_POSTHOG_HOST || "https://us.i.posthog.com";
